import { render, staticRenderFns } from "./PasswordFormInvira.vue?vue&type=template&id=345c0c9e&scoped=true&"
import script from "./PasswordFormInvira.vue?vue&type=script&lang=js&"
export * from "./PasswordFormInvira.vue?vue&type=script&lang=js&"
import style0 from "./PasswordFormInvira.vue?vue&type=style&index=0&id=345c0c9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345c0c9e",
  null
  
)

export default component.exports